import { render } from "./createexpense.vue?vue&type=template&id=235489fb"
import script from "./createexpense.vue?vue&type=script&lang=js"
export * from "./createexpense.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-AfyunProd\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__